import type { ComponentProps, ReactNode } from 'react';
import { Input } from '@/shared/ui/primitives/input';

/** Props do MaskedInput: o valor é sempre sem máscara. */
export type MaskedInputProps = Omit<ComponentProps<typeof Input>, 'value' | 'onChange'> & {
  value: string;
  onChange: (value: string) => void;
};

/** Máscara de um campo: como exibir e como extrair o valor sem máscara. */
export interface InputMask {
  mask: (value: string) => string;
  unmask: (value: string) => string;
}

/** Campo com máscara de exibição; entrega o valor sem máscara a cada digitação. */
export function MaskedInput({
  value,
  onChange,
  mask,
  unmask,
  ...props
}: MaskedInputProps & InputMask): ReactNode {
  return (
    <Input
      autoComplete="off"
      {...props}
      value={mask(value)}
      onChange={(event) => {
        onChange(unmask(event.target.value));
      }}
    />
  );
}
